module.exports = __webpack_public_path__ + "static/img/introduction-3.d0195e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/introduction-3.png
// module id = Q4d2
// module chunks = 0